import React, { useEffect, useRef } from 'react';

/*
 * PROD-7828 D110 — the confirm step before a run starts, naming the count and the month (B7). It takes
 * the place of the dialog's footer and takes focus. note: the server's SELECTION_CHANGED sentence when
 * the confirm is asked again with the new count. Props-only.
 */
const RunConfirm = ({ text, note = '', confirm_label, busy, on_confirm, on_back }) => {
  const ref = useRef(null);
  // Focus on opening and when the server asks again (a new note); ticking elsewhere never pulls it.
  useEffect(() => {
    if (ref.current) ref.current.focus({ preventScroll: true });
  }, [note]);
  return (
    <section
      className="tp-banner tp-banner-warn"
      aria-label="Confirm the run"
      tabIndex={-1}
      ref={ref}
    >
      {note ? (
        <div className="tp-na-headline" role="alert">
          {note}
        </div>
      ) : null}
      <div>{text}</div>
      <div className="tp-modal-ft">
        {/* aria-disabled, not disabled: disabling the focused button drops focus (CD-114). */}
        <button
          type="button"
          className="tp-btn-ghost"
          onClick={busy ? undefined : on_back}
          aria-disabled={busy ? 'true' : undefined}
        >
          Back
        </button>
        <button
          type="button"
          className="tp-btn tp-btn-danger"
          onClick={busy ? undefined : on_confirm}
          aria-disabled={busy ? 'true' : undefined}
        >
          {busy ? 'Starting…' : confirm_label}
        </button>
      </div>
    </section>
  );
};

export default RunConfirm;
